// src/views/Form.js
import React, { useState } from 'react';

function Form() {
  const [data, setData] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Datos enviados:', data);
  };

  return (
    <div>
      <h1>Formulario</h1>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="inputData" className="form-label">Dato</label>
          <input 
            type="text" 
            id="inputData" 
            className="form-control" 
            value={data} 
            onChange={(e) => setData(e.target.value)} 
          />
        </div>
        <button type="submit" className="btn btn-primary">Enviar</button>
      </form>
    </div>
  );
}

export default Form;
